import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from '../app-routing.module';
import { AppComponent } from '../app.component';

import { SharedModule } from '../shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from '../core/core.module';
import { HttpClientModule } from '@angular/common/http';
import { NgTemplateOutlet } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// MSAL RESTRICTION: Comment out MSAL imports
import {
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import { InteractionType, PublicClientApplication } from '@azure/msal-browser';

// MSAL RESTRICTION: Comment out config import
import { msalConfig, DevApiProtectedResourceMap } from '../auth-config';
import { ActUserModule } from '@features/act-user/act-user.module';
import { rootReducers } from '../store/root-reducers';
import { rootEffects } from '../store/root-effects';
import { environment } from 'src/environments/environment';
import { LayoutComponent } from '../layout.component';
import { NgIdleModule } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { ServiceWorkerModule } from '@angular/service-worker';
import { CurrentUserFlowService } from '@core/services/current-user/current-user.service';
import { SignalrService } from '@core/services/signalR/signalR.service';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [AppComponent, LayoutComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,

    HttpClientModule,
    NgTemplateOutlet,
    // StoreRouterConnectingModule.forRoot(),
    StoreModule.forRoot(rootReducers),
    EffectsModule.forRoot(rootEffects), // It was added for the creation of providers because the 'createFeature' function doesn't handle it
    StoreDevtoolsModule.instrument({
      logOnly: !isDevMode(),
      connectInZone: true,
    }),
    NgIdleModule.forRoot(),
    ActUserModule,
    // MSAL RESTRICTION: Comment out MSAL module initialization
    MsalModule.forRoot(
      new PublicClientApplication(msalConfig),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: environment.ApiScopes,
        },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: DevApiProtectedResourceMap,
      },
    ),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode }),
      connectInZone: true,
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    // MSAL RESTRICTION: Comment out MSAL interceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    // MSAL RESTRICTION: Comment out MSAL guard
    MsalGuard,
    Keepalive,
    CurrentUserFlowService,
    SignalrService,
  ],
  // MSAL RESTRICTION: Comment out MSAL redirect component
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppStandardModule {}
